import { DateTime } from 'luxon';
import { DEFAULT_BROKER_TIMEZONE } from '../appointment-datetime';

export const getWeekLongFormat = (date: Date) => {
  return new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(date);
};

export const getMonthLongFormat = (date: Date) => {
  return new Intl.DateTimeFormat('en-US', { month: 'long' }).format(date);
};

export const getHourWith12HourClock = (date: DateTime) => {
  return date.hour % 12 === 0 ? 12 : date.hour % 12;
};

export const getMinutesWithFormat = (date: DateTime) => {
  return date.minute >= 10 ? date.minute.toString() : '0' + date.minute;
};

export const getISODateOrMonthFormat = (n: number) => {
  return n > 9 ? n.toString() : '0' + n.toString();
};

export const getTimeFormat = (s: string) => {
  const date = new Date(s);
  return `${getWeekLongFormat(date)}, ${date.getDate()} ${getMonthLongFormat(date)}`;
};

export const formatTimeAmPmAndDate = (s: string) => {
  //Expected output format example: 8:15AM Thursday 25 February
  return DateTime.fromISO(s).toFormat('h:mma cccc d LLLL');
};

export const formatDateAndTimeForCard = (s: string, tz?: string) => {
  if (!s) return;
  const timezone = tz || DEFAULT_BROKER_TIMEZONE;

  return {
    //Expected output format example: Monday, 10 Jan 2022
    formattedDate: DateTime.fromISO(s).setZone(timezone).toFormat('cccc, dd LLL yyyy'),
    //Expected output format example: 2:00 PM
    formattedTime: DateTime.fromISO(s).setZone(timezone).toFormat('h:mm a'),
  };
};

export const getHalfday = (date: DateTime) => {
  return date.hour >= 12 ? 'PM' : 'AM';
};

export const getWeekdayDayMonthYear = (date: string, tz?: string) => {
  const timezone = tz || DEFAULT_BROKER_TIMEZONE;
  // Expected output format example Thursday, 06 October 2021
  const format = 'cccc, dd LLLL y';

  if (date === 'now') return DateTime.local().setZone(timezone).toFormat(format);
  return DateTime.fromISO(date).toFormat(format);
};

export const getWeekdayMonthDayYear = (date: string, tz?: string) => {
  const timezone = tz || DEFAULT_BROKER_TIMEZONE;
  // Expected output format example Thursday, 06 October 2021
  const format = 'cccc, LLLL dd y';

  if (date === 'now') return DateTime.local().setZone(timezone).toFormat(format);
  return DateTime.fromISO(date).toFormat(format);
};

//Eg: Today, Tomorrow, Monday, Tuesday
export const getWeekDayFromString = (date: string) => {
  const formattedLocalToday = DateTime.local().toFormat('y-LL-dd');
  const formattedLocalTomorrow = DateTime.local().plus({ days: 1 }).toFormat('y-LL-dd');
  switch (date) {
    case formattedLocalToday:
      return 'Today';
    case formattedLocalTomorrow:
      return 'Tomorrow';
    default:
      return DateTime.fromISO(date).toFormat('cccc');
  }
};

//Eg: 29-December
export const getDayMonthFromString = (date: string) => {
  return DateTime.fromISO(date).toFormat('d LLLL');
};
